export default __webpack_public_path__ + "static/media/misc-books2-480w.17d67f69.png";